import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import usePromotions from "common/datahooks/usePromotions";
import useWorkspaceDetails from "common/datahooks/useWorkspaceDetails";
import { getOutreachLicenseCount } from "common/helpers/workspaceLicenseCounts";
import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
} from "common/types";

interface ReturnedSubscription<
  SubscriptionType extends
    | RentedSubscription
    | AgencySubscription
    | Subscription,
> {
  subscription: SubscriptionType;
  seats: number;
}

export default function useSubscriptions() {
  const { id: workspaceId, agency_subscription_status } =
    useSelectedWorkspaceContext();
  const { workspace, isLoadingWorkspace } = useWorkspaceDetails(workspaceId);
  const { agencyPlan, isLoadingPromotions } = usePromotions();

  let agency: ReturnedSubscription<AgencySubscription> & {
    unassigned_seats: number;
  };
  let user: ReturnedSubscription<Subscription>;

  if (workspace) {
    const { subscription } = workspace;
    const outreachSeatCount = getOutreachLicenseCount(workspace) ?? 1;

    if (subscription) {
      user = {
        subscription,
        seats: outreachSeatCount,
      };
    }
  }
  if (agencyPlan && agency_subscription_status) {
    const { subscription, license_count, unassigned_license_count } =
      agencyPlan;
    agency = {
      subscription,
      seats: license_count,
      unassigned_seats: unassigned_license_count,
    };
  }

  return {
    agency,
    user,
    isLoadingSubscriptions: isLoadingPromotions || isLoadingWorkspace,
  };
}
